import { useEffect, useState } from 'react';

const API = (process.env.REACT_APP_API_URL || 'http://localhost:8000') + '/api/ic-kontrol';

const KONTROL_TURLERI = [
  { value: 'yonlendirici', label: 'Yönlendirici',  ikon: '🎯', renk: '#1a56db', bg: '#eff6ff', aciklama: 'İstenilen sonuca ulaşmak için yol gösteren kontroller' },
  { value: 'onleyici',     label: 'Önleyici',       ikon: '🛡️', renk: '#057a55', bg: '#ecfdf5', aciklama: 'Hata ve usulsüzlükleri oluşmadan önleyen kontroller' },
  { value: 'tespit_edici', label: 'Tespit Edici',   ikon: '🔎', renk: '#b45309', bg: '#fffbeb', aciklama: 'Oluşan hata ve usulsüzlükleri tespit eden kontroller' },
  { value: 'duzeltici',   label: 'Düzeltici',       ikon: '🔧', renk: '#9f1239', bg: '#fff1f2', aciklama: 'Tespit edilen sorunları düzelten kontroller' },
];

const YONTEMLER = [
  'Onaylama', 'Yetkilendirme', 'Doğrulama', 'Mutabakat', 'Gözetim',
  'Ön Mali Kontrol', 'Muhasebe Kontrolü', 'Çift İmza', 'Görevler Ayrılığı',
  'Raporlama', 'Karşılaştırma', 'Analiz', 'İnceleme', 'Örnekleme',
  'Varlık Sayımı', 'BT Kontrolü', 'Diğer'
];

const BOŞ_FORM: any = {
  isletme_id: '', faaliyet_adi: '', aciklama: '', kontrol_turu: 'onleyici',
  kontrol_yontemi: 'Onaylama', ilgili_risk_id: '', sorumlu_adi: '',
  uygulama_sikligi: 'aylik', maliyet_tahmini: '', etkinlik_degerlendirmesi: '',
};

export default function IcKontrolFaaliyetler() {
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };

  const [faaliyetler, setFaaliyetler] = useState<any[]>([]);
  const [riskler, setRiskler] = useState<any[]>([]);
  const [isletmeler, setIsletmeler] = useState<any[]>([]);
  const [filtreTur, setFiltreTur] = useState('');
  const [modal, setModal] = useState(false);
  const [secili, setSecili] = useState<any>(null);
  const [form, setForm] = useState({ ...BOŞ_FORM });
  const [kaydediliyor, setKaydediliyor] = useState(false);

  const yukle = () => {
    const qs = filtreTur ? `?kontrol_turu=${filtreTur}` : '';
    fetch(`${API}/kontrol-faaliyetleri${qs}`, { headers })
      .then(r => r.json()).then(d => setFaaliyetler(Array.isArray(d) ? d : []));
  };

  useEffect(() => {
    yukle();
    fetch(`${API}/riskler`, { headers }).then(r => r.json()).then(d => setRiskler(Array.isArray(d) ? d : []));
    fetch((process.env.REACT_APP_API_URL || 'http://localhost:8000') + '/api/isletmeler', { headers }).then(r => r.json()).then(d => setIsletmeler(Array.isArray(d) ? d : []));
  }, [filtreTur]);

  const kaydet = async () => {
    setKaydediliyor(true);
    const url = secili ? `${API}/kontrol-faaliyetleri/${secili.id}` : `${API}/kontrol-faaliyetleri`;
    const method = secili ? 'PUT' : 'POST';
    const payload = { ...form, maliyet_tahmini: form.maliyet_tahmini ? Number(form.maliyet_tahmini) : null, ilgili_risk_id: form.ilgili_risk_id || null };
    const res = await fetch(url, { method, headers, body: JSON.stringify(payload) });
    if (res.ok) { setModal(false); setSecili(null); setForm({ ...BOŞ_FORM }); yukle(); }
    setKaydediliyor(false);
  };

  const sil = async (id: number) => {
    if (!confirm('Bu kontrol faaliyetini silmek istediğinizden emin misiniz?')) return;
    await fetch(`${API}/kontrol-faaliyetleri/${id}`, { method: 'DELETE', headers });
    yukle();
  };

  const turSayilari = KONTROL_TURLERI.map(t => ({
    ...t,
    sayi: faaliyetler.filter(f => f.kontrol_turu === t.value).length
  }));

  const turBilgi = (tur: string) => KONTROL_TURLERI.find(t => t.value === tur) || KONTROL_TURLERI[0];

  return (
    <div style={{ padding: '24px', maxWidth: 1200 }}>
      {/* Başlık */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 22, color: '#111827' }}>✅ Kontrol Faaliyetleri</h1>
          <p style={{ margin: '4px 0 0', fontSize: 13, color: '#6b7280' }}>
            7-12. Standartlar • Kontrol Stratejileri, Prosedürler, Görevler Ayrılığı, Hiyerarşik Kontrol, Süreklilik, BT Kontrolleri
          </p>
        </div>
        <button onClick={() => { setSecili(null); setForm({ ...BOŞ_FORM }); setModal(true); }} style={{
          background: '#057a55', color: '#fff', border: 'none', borderRadius: 8,
          padding: '10px 20px', cursor: 'pointer', fontWeight: 600, fontSize: 14
        }}>+ Yeni Kontrol Faaliyeti</button>
      </div>

      {/* Mevzuat Notu */}
      <div style={{ background: '#ecfdf5', border: '1px solid #a7f3d0', borderRadius: 8, padding: '10px 16px', marginBottom: 20, fontSize: 12, color: '#065f46' }}>
        ⚖️ <strong>7. Standart:</strong> Her bir faaliyet ve risk için uygun kontrol strateji ve yöntemleri belirlenmeli ve uygulanmalıdır. &bull;{' '}
        <strong>9. Standart:</strong> Onaylama, uygulama, kaydetme ve kontrol görevleri farklı kişilere verilmelidir (Görevler Ayrılığı İlkesi).
      </div>

      {/* Kontrol Türü Özet Kartları */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 12, marginBottom: 20 }}>
        {turSayilari.map(t => (
          <div key={t.value} onClick={() => setFiltreTur(filtreTur === t.value ? '' : t.value)} style={{
            background: filtreTur === t.value ? t.bg : '#fff',
            border: `2px solid ${filtreTur === t.value ? t.renk : '#e5e7eb'}`,
            borderRadius: 10, padding: '14px 16px', cursor: 'pointer', transition: 'all 0.15s'
          }}>
            <div style={{ fontSize: 24, marginBottom: 8 }}>{t.ikon}</div>
            <div style={{ fontWeight: 700, fontSize: 14, color: '#111827' }}>{t.label}</div>
            <div style={{ fontSize: 24, fontWeight: 800, color: t.renk, marginTop: 4 }}>{t.sayi}</div>
            <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 4 }}>{t.aciklama}</div>
          </div>
        ))}
      </div>

      {/* Faaliyetler Tablosu */}
      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead style={{ background: '#f9fafb' }}>
            <tr>
              {['Kontrol Türü', 'Faaliyet Adı / Açıklama', 'Yöntem', 'Uygulama Sıklığı', 'Sorumlu', 'İşlem'].map(h => (
                <th key={h} style={{ padding: '10px 12px', textAlign: 'left', border: '1px solid #e5e7eb', color: '#374151', fontWeight: 600 }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {faaliyetler.length === 0 && (
              <tr><td colSpan={6} style={{ textAlign: 'center', padding: 40, color: '#9ca3af' }}>
                ℹ️ Henüz kontrol faaliyeti kaydı bulunmamaktadır.
              </td></tr>
            )}
            {faaliyetler.map(f => {
              const tur = turBilgi(f.kontrol_turu);
              return (
                <tr key={f.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                  <td style={{ padding: '10px 12px', border: '1px solid #e5e7eb', whiteSpace: 'nowrap' }}>
                    <span style={{ background: tur.bg, color: tur.renk, padding: '3px 10px', borderRadius: 12, fontSize: 12, fontWeight: 600 }}>
                      {tur.ikon} {tur.label}
                    </span>
                  </td>
                  <td style={{ padding: '10px 12px', border: '1px solid #e5e7eb', maxWidth: 300 }}>
                    <div style={{ fontWeight: 600, color: '#111827', marginBottom: 2 }}>{f.faaliyet_adi}</div>
                    {f.aciklama && <div style={{ fontSize: 11, color: '#6b7280', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{f.aciklama}</div>}
                  </td>
                  <td style={{ padding: '10px 12px', border: '1px solid #e5e7eb', color: '#374151' }}>{f.kontrol_yontemi || '-'}</td>
                  <td style={{ padding: '10px 12px', border: '1px solid #e5e7eb', color: '#374151', whiteSpace: 'nowrap' }}>
                    {f.uygulama_sikligi === 'gunluk' ? '📅 Günlük' :
                     f.uygulama_sikligi === 'haftalik' ? '📅 Haftalık' :
                     f.uygulama_sikligi === 'aylik' ? '📅 Aylık' :
                     f.uygulama_sikligi === 'uc_aylik' ? '📅 3 Aylık' :
                     f.uygulama_sikligi === 'alti_aylik' ? '📅 6 Aylık' :
                     f.uygulama_sikligi === 'yillik' ? '📅 Yıllık' :
                     f.uygulama_sikligi || '-'}
                  </td>
                  <td style={{ padding: '10px 12px', border: '1px solid #e5e7eb', color: '#6b7280', fontSize: 12 }}>{f.sorumlu_adi || '-'}</td>
                  <td style={{ padding: '10px 12px', border: '1px solid #e5e7eb', whiteSpace: 'nowrap' }}>
                    <button onClick={() => { setSecili(f); setForm({ ...f, ilgili_risk_id: f.ilgili_risk_id || '', maliyet_tahmini: f.maliyet_tahmini || '' }); setModal(true); }}
                      style={{ background: '#f9fafb', border: '1px solid #d1d5db', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontSize: 12, marginRight: 6 }}>Düzenle</button>
                    <button onClick={() => sil(f.id)}
                      style={{ background: '#fef2f2', color: '#dc2626', border: 'none', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontSize: 12 }}>Sil</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div style={{ background: '#fff', borderRadius: 12, width: '100%', maxWidth: 700, maxHeight: '90vh', overflowY: 'auto', padding: 28 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
              <h2 style={{ margin: 0, fontSize: 18 }}>{secili ? '✏️ Kontrol Faaliyeti Düzenle' : '+ Yeni Kontrol Faaliyeti'}</h2>
              <button onClick={() => { setModal(false); setSecili(null); }} style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#9ca3af' }}>×</button>
            </div>

            {/* Kontrol Türü Seçimi */}
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 8 }}>Kontrol Türü * (7.2. Şart)</label>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 8 }}>
                {KONTROL_TURLERI.map(t => (
                  <label key={t.value} style={{
                    display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4,
                    padding: '10px 8px', borderRadius: 8, cursor: 'pointer', textAlign: 'center',
                    border: `2px solid ${form.kontrol_turu === t.value ? t.renk : '#e5e7eb'}`,
                    background: form.kontrol_turu === t.value ? t.bg : '#fff', transition: 'all 0.15s'
                  }}>
                    <input type="radio" name="ktip" value={t.value} checked={form.kontrol_turu === t.value}
                      onChange={() => setForm(f => ({ ...f, kontrol_turu: t.value }))} style={{ display: 'none' }} />
                    <span style={{ fontSize: 20 }}>{t.ikon}</span>
                    <span style={{ fontSize: 12, fontWeight: 600, color: t.renk }}>{t.label}</span>
                  </label>
                ))}
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <div style={{ gridColumn: 'span 2' }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Faaliyet Adı *</label>
                <input value={form.faaliyet_adi} onChange={e => setForm(f => ({ ...f, faaliyet_adi: e.target.value }))}
                  placeholder="Kontrol faaliyetinin adı..." style={girisS()} />
              </div>
              <div style={{ gridColumn: 'span 2' }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Açıklama</label>
                <textarea value={form.aciklama} onChange={e => setForm(f => ({ ...f, aciklama: e.target.value }))}
                  rows={2} placeholder="Kontrol faaliyetinin nasıl uygulanacağı..." style={{ ...girisS(), resize: 'vertical' }} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Kontrol Yöntemi (7.1. Şart)</label>
                <select value={form.kontrol_yontemi} onChange={e => setForm(f => ({ ...f, kontrol_yontemi: e.target.value }))} style={girisS()}>
                  {YONTEMLER.map(y => <option key={y} value={y}>{y}</option>)}
                </select>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Uygulama Sıklığı</label>
                <select value={form.uygulama_sikligi} onChange={e => setForm(f => ({ ...f, uygulama_sikligi: e.target.value }))} style={girisS()}>
                  <option value="gunluk">Günlük</option>
                  <option value="haftalik">Haftalık</option>
                  <option value="aylik">Aylık</option>
                  <option value="uc_aylik">3 Aylık</option>
                  <option value="alti_aylik">6 Aylık</option>
                  <option value="yillik">Yıllık</option>
                  <option value="olay_bazli">Olay Bazlı</option>
                </select>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Sorumlu</label>
                <input value={form.sorumlu_adi} onChange={e => setForm(f => ({ ...f, sorumlu_adi: e.target.value }))}
                  placeholder="Ad Soyad / Unvan" style={girisS()} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Tahmini Maliyet (₺)</label>
                <input type="number" value={form.maliyet_tahmini} onChange={e => setForm(f => ({ ...f, maliyet_tahmini: e.target.value }))}
                  placeholder="0" style={girisS()} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>İlgili Risk</label>
                <select value={form.ilgili_risk_id} onChange={e => setForm(f => ({ ...f, ilgili_risk_id: e.target.value }))} style={girisS()}>
                  <option value="">Risk Seçin (Opsiyonel)</option>
                  {riskler.map(r => <option key={r.id} value={r.id}>{r.risk_no} — {r.risk_adi.slice(0, 50)}</option>)}
                </select>
              </div>
              <div style={{ gridColumn: 'span 2' }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Etkinlik Değerlendirmesi</label>
                <textarea value={form.etkinlik_degerlendirmesi} onChange={e => setForm(f => ({ ...f, etkinlik_degerlendirmesi: e.target.value }))}
                  rows={2} placeholder="Bu kontrolün etkinliği nasıl değerlendiriliyor? Fayda/maliyet analizi..." style={{ ...girisS(), resize: 'vertical' }} />
              </div>
            </div>

            <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 8, padding: '10px 14px', marginTop: 14, fontSize: 12, color: '#92400e' }}>
              💡 <strong>7.4. Şart:</strong> Belirlenen kontrol yönteminin maliyeti beklenen faydayı aşmamalıdır.
            </div>

            <div style={{ display: 'flex', gap: 12, marginTop: 20, justifyContent: 'flex-end' }}>
              <button onClick={() => { setModal(false); setSecili(null); }} style={{ padding: '10px 20px', borderRadius: 8, border: '1px solid #d1d5db', background: '#fff', cursor: 'pointer', fontSize: 14 }}>İptal</button>
              <button onClick={kaydet} disabled={kaydediliyor || !form.faaliyet_adi} style={{
                padding: '10px 24px', borderRadius: 8, border: 'none', fontSize: 14, fontWeight: 600, cursor: 'pointer',
                background: !form.faaliyet_adi ? '#9ca3af' : '#057a55', color: '#fff'
              }}>{kaydediliyor ? 'Kaydediliyor...' : secili ? 'Güncelle' : 'Kaydet'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function girisS(): React.CSSProperties {
  return { width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13, outline: 'none', boxSizing: 'border-box' };
}
